<template>
    <div class="context">
        <div class="table_box">
            <div class="search_box">
                <div class="search_item">
                    <div class="title">病种：</div>
                    <div class="input_box">
                        <div v-for="(item, index) in allIllData"
                             :key="index"
                             :class="tumour_id === item.tumour_id?'actived_btn':''"
                             @click="changeIll(item.tumour_id)"
                             class="btn">
                            {{item.name}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="table_main">
                <table class="table" cellspacing="0" width="100%">
                    <tr class="header_t">
                        <th>周期</th>
                        <th v-for="(item, index) in item_types" :key="index">
                            {{item}}
                        </th>
                    </tr>
                    <tr class="table_item">
                        <td>推送规则</td>
                        <td v-for="(item, index) in tumour_configs"
                            class="rule_btn"
                            @click="openRule(item_types[index])"
                            :key="index">
                            <span v-if="item">{{item | showRule}}</span>
                            <span v-else>暂无规则</span>
                        </td>
                    </tr>
                    <tr v-for="(item, index) in tumour_cycle_configs"
                        :key="index"
                        class="table_item">
                        <td>{{item.name}}</td>
                        <td v-for="(items, indexs) in item.tumour_cycle_configs"
                            :key="indexs"
                            class="rule_btn">
                            <div class="tuwen">
                                <span @click="openText(item, item_types[indexs])"
                                      v-if="items && items.cycle_items &&
                                       items.cycle_items.length > 0">
                                    {{items.cycle_items.length}}
                                    {{indexs | showLast}}
                                </span>
                                <span @click="openText(item, item_types[indexs])"
                                      v-else>0{{indexs | showLast}}</span>
                            </div>
                            <div class="tuisong_btn">
                                <el-button @click="setPushText(items)"
                                           size="mini">
                                    定点推送
                                    <span v-if="items && items.cycle_items &&
                                       items.cycle_items.length > 0">
                                        ：{{items | showPushLength}}
                                        {{indexs | showLast}}
                                    </span>
                                </el-button>
                            </div>
                        </td>
                    </tr>
                    <tr class="table_item">
                        <td>合计</td>
                        <td v-for="(item, index) in total" :key="index">
                            {{item}} {{index | showLast}}
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState, mapMutations} from 'vuex'
    import {ssGet, ssSet} from "../../global/utils";

    export default {
        name: "tableView",
        data() {
            return {
                tumour_id: '',
                item_types: ['图文知识', '医生视频', '调研', '每日关怀', '医疗服务包',],
                tumour_configs: [],
                tumour_cycle_configs: [],
                total: []
            }
        },
        computed: {
            ...mapState("comInformationData", [
                'allIllData'
            ])
        },
        filters: {
            showRule(item) {
                let list = [
                    {name: '按天', value: 'DAY'},
                    {name: '按月', value: 'MONTH'},
                    {name: '按周', value: 'WEEK'},
                ];

                if (item.push_day_cycle === 'DAY') {
                    return '按天：每隔' + item.push_per_cycle + '天'
                } else {
                    let text = list.filter(v => v.value === item.push_day_cycle);
                    console.log(item, '105');
                    return text[0].name + '：' + item.push_per_cycle
                }
            },
            showLast(index) {
                let text = '';
                switch (index) {
                    case 0:
                        text = '篇';
                        break;
                    case 1:
                        text = '条';
                        break;
                    case 2:
                        text = '条';
                        break;
                    case 3:
                        text = '套';
                        break;
                    case 4:
                        text = '套';
                        break;
                }
                return text
            },
            showPushLength(item) {
                let num = 0;
                if (item.cycle_start_item_id) {
                    num ++;
                }
                if (item.cycle_middle_item_id) {
                    num ++;
                }
                if (item.cycle_end_item_id) {
                    num ++;
                }
                return num
            }
        },
        mounted() {
            if (this.allIllData && this.allIllData.length > 0) {
                if (ssGet('huodong_tumour_id')) {
                    this.changeIll(Number(ssGet('huodong_tumour_id')))
                } else {
                    this.changeIll(this.allIllData[0].tumour_id)
                }
            }
        },
        methods: {
            ...mapMutations('learnData', {
                setRuleData: 'setRuleData',
                setPushData: 'setPushData',
                setLinePushData: 'setLinePushData',
                setTextData: 'setTextData'
            }),
            changeIll(val) {
                this.tumour_id = val;
                this.getTableData()
            },
            getTableData() {
                let params = {
                    ill_id: this.tumour_id
                };
                ssSet('huodong_tumour_id', this.tumour_id);
                this.httpGet('/push_ill_config_all', params).then(res => {
                    this.item_types = res.data.item_types;
                    this.tumour_configs = res.data.tumour_configs;
                    this.tumour_cycle_configs = res.data.tumour_cycle_configs;
                    this.total = res.data.total
                })
            },
            openRule(type) { // 规则
                let params = {
                    ill_id: this.tumour_id,
                    item_type: type,
                };
                this.httpGet('/push_ill_config', params).then(res => {
                    if (res.data) {
                        this.setRuleData(res.data);
                    } else {
                        this.setRuleData(params);
                    }
                    this.$emit('changeTopTab', 'ruleView')
                });
            },
            openText(item, type) { // 图文
                // console.log(item, '199');
                let params = {
                    ill_id: item.tumour_id,
                    ill_cycle_id: item.tumour_cycle_id,
                    item_type: type,
                };
                this.httpGet('/push_cycle_config', params).then(res => {
                    if (res.data) {
                        this.setTextData(res.data);
                    } else {
                        this.setTextData(params);
                    }
                    this.$emit('changeTopTab', 'imageText')
                });
            },
            setPushText(item) { // 推送
                // console.log(item, '171');
                if (item && item.cycle_items && item.cycle_items.length > 0) {
                    let params = {
                        ill_id: item.tumour_id,
                        ill_cycle_id: item.tumour_cycle_id,
                        item_type: item.item_type,
                    };
                    this.setPushData(item);
                    this.httpGet('/push_cycle_timing_config', params).then(res => {
                        this.setLinePushData(res.data);
                        this.$emit('changeTopTab', 'setTextPush')
                    });
                } else {
                    this.$message({
                        type: 'warning',
                        message: '暂无图文，请选择图文之后再定点推送。',
                        duration: 1500
                    })
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    $view_background: rgb(246,247,248);
    $btn_border: rgb(246,247,248);
    .context {
        width: 100%;
        height: 100%;
        background: $view_background;

        .table_box {
            width: 100%;
            height: 100%;
            overflow: hidden;
            overflow-y: auto;
            .search_box {
                line-height: 40px;
                padding-left: 10px;
                /*background: #fff;*/
                .search_item {
                    display: flex;
                    .title {
                        color: #8d8d8d;
                        padding-right: 5px;
                        font-size: .875rem;
                    }
                    .input_box {
                        display: flex;
                        .btn {
                            height: 25px;
                            line-height: 25px;
                            font-size: .875rem;
                            padding: 0 10px;
                            box-sizing: border-box;
                            margin: 7px 10px;
                            cursor: pointer;
                        }
                        .actived_btn {
                            box-sizing: border-box;
                            border: 1px solid #38adff;
                            border-radius: 3px;
                        }
                    }
                }
            }
            .table_main {
                .table {
                    border: 1px solid #ebeef5;
                    background: #fff;
                    padding: 24px;
                    .header_t {
                        display: flex;
                        th {
                            border-bottom: 1px solid #ebeef5;
                            box-sizing: border-box;
                            font-size: .875rem;
                            background: #fff;
                            color: #909399;
                            padding: 12px 0;
                            flex: 1;
                        }
                    }
                    .table_item {
                        display: flex;
                        td {
                            border-bottom: 1px solid #ebeef5;
                            box-sizing: border-box;
                            text-align: center;
                            font-size: .875rem;
                            color: #606266;
                            padding: 9px 0;
                            line-height: 25px;
                            flex: 1;
                        }
                        .rule_btn {
                            cursor: pointer;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            .tuwen {
                                box-sizing: border-box;
                            }
                            .tuisong_btn {

                            }
                        }
                    }
                    tr:nth-child(even) {
                        background: #fff;
                    }
                    tr:nth-child(odd) {
                        background: #fafafa;
                    }
                }
            }
        }
    }
</style>